<script setup lang="ts">
import { appStore } from "../../stores/app";
import { answerPlacement, placementPopup } from "./placement";
</script>

<!-- Asks where an arm goes (back/center/front). Clicking the background means "no placement". -->
<template>
    <div class="placement-modal modal" :class="{ 'is-active': appStore.modal === 'placement' }">
        <div class="modal-background" @click="answerPlacement(undefined)"></div>
        <div class="modal-card">
            <div class="modal-card-head">
                <div class="modal-card-title">Placement</div>
            </div>
            <section class="modal-card-body">
                <button class="align-back" title="back" @click="answerPlacement(undefined)"><img src="/images/icons/align-back.svg"/></button>
                <button v-for="placement in placementPopup.placements" :key="placement" :class="'align-' + placement" :title="placement" @click="answerPlacement(placement)"><img :src="`/images/icons/align-${placement}.svg`"/></button>
            </section>
        </div>
    </div>
</template>
